import { Adapter as r } from "../../../../../adapter.js";
import { TierDesignModel as e } from "./tierDesign.model.js";
class s extends r {
  adapt(o) {
    return new e({
      corpLogo: o.corp_logo,
      currencyLogo: o.currency_logo,
      cardBackgroundImage: o.card_background_image,
      progressBarColor: o.progress_bar_color,
      balanceBackgroundColor: o.balance_background_color,
      labelLevelName: o.label_level_name,
      labelCustomerName: o.label_customer_name,
      labelRewardName: o.label_reward_name,
      balanceProgressVisibility: o.balance_progress_visibility,
      font: o.font,
      highlightColor: o.highlight_color,
      backgroundColor: o.background_color,
      cardColor: o.card_color,
      stampsColor: o.stamps_color,
      contentTextColor: o.content_text_color,
      texts: o.texts
    });
  }
  serialize(o) {
  }
}
export {
  s as TierDesignAdapter
};
//# sourceMappingURL=tierDesign.adapter.js.map
